export const auditCategories = [
  'summary',
  'gear_overview',
  'gear_upgrades',
  'enchantments',
  'vault',
  'raids_weekly',
  'raids_overall',
  'raids_timeline',
  'dungeons_weekly',
  'dungeons_overall',
  'collections',
  'reputations',
  'pvp',
  'professions',
] as const

type AuditCategory = typeof auditCategories[number]

export const auditCategoriesByGameVersion: Record<string, AuditCategory[]> = {
  live: [
    'summary',
    'gear_overview',
    'gear_upgrades',
    'enchantments',
    'vault',
    'raids_weekly',
    'raids_overall',
    'raids_timeline',
    'dungeons_weekly',
    'dungeons_overall',
    'collections',
    'reputations',
    'pvp',
    'professions',
  ],
  classic_progression: [
    'gear_overview',
    'enchantments',
    'raids_weekly',
    'raids_overall',
    'collections',
    'pvp',
  ],
  classic_anniversary: ['gear_overview', 'enchantments'],
  classic_era: ['gear_overview', 'enchantments'],
  classic_forever: ['summary', 'pvp', 'professions'],
}

export default AuditCategory
